import React, { useContext, useState } from "react";
// import { PersonnelType, UserType } from "../../../../types/GlobalType";
// import { personnelContext } from "../../../../context/AppContext";
import { useOutletContext } from "react-router-dom";
import moment from "moment";
import UpdatePasswordAccount from "../account/UpdatePasswordAccount.tsx";
import { UserType } from "../../../../types/GlobalType.ts";

type MyContextType = {
  setOpen: React.Dispatch<React.SetStateAction<Boolean>>;
  accountExists: UserType | undefined;
  context: UserType | undefined;
  dispatchReload: () => void;
};

const CompteInfo = () => {
  // const personnelData: PersonnelType = useContext(personnelContext);
  const context: MyContextType = useOutletContext();

  const [openUpdate, setOpenUpdate] = useState<boolean>(false);

  return (
    <div className="tuteur_info">
      <div className="title_section">
        <h4 className="">Détail du compte</h4>
        <span onClick={() => setOpenUpdate(true)}>
          Modifier le mot de passe
        </span>
      </div>
      <table>
        <tr>
          <td>Création de compte:</td>
          {context.context && (
            <td>
              {moment(context.context.user_created_at).format("LLL")}
              {/* {moment(context.context.user_created_at).format("DD-MM-YYYY, HH:MM:SS")} */}
            </td>
          )}
        </tr>
        <tr>
          <td>Fonction:</td>
          {context.context && (
            <td>{context.context.fonction_designation?.toUpperCase()}</td>
          )}
        </tr>
        <tr>
          <td>Niveau d'étude:</td>
          {context.context && (
            <td>{context.context.grade_designation?.toUpperCase()}</td>
          )}
        </tr>
        <tr>
          <td>Email:</td>
          {context.context && <td>{context.context.email}</td>}
        </tr>
        <tr>
          <td>Mot de passe:</td>
          <td>{"*************"}</td>
        </tr>
      </table>

      {openUpdate && (
        <UpdatePasswordAccount
          setOpen={setOpenUpdate}
          //for singlePersonnel
          setOpen2={context.setOpen}
          data={context.context}
          // setOpen2={props.setOpen}
          // dispatchReload={props.dispatchReload}
        />
      )}
    </div>
  );
};

export default CompteInfo;
